import { noteListResponseSchema, noteResponseSchema, type Note } from '@chatapp-inbox/shared';
import { request } from './http';

const base = (conversationId: string): string =>
  `/conversations/${encodeURIComponent(conversationId)}/notes`;

/** Notas internas da conversa, da mais antiga para a mais nova. Nunca chegam ao cliente. */
export async function listNotes(conversationId: string, signal?: AbortSignal): Promise<Note[]> {
  const { notes } = await request(base(conversationId), {
    schema: noteListResponseSchema,
    ...(signal ? { signal } : {}),
  });
  return notes;
}

export async function createNote(conversationId: string, text: string): Promise<Note> {
  const { note } = await request(base(conversationId), {
    method: 'POST',
    body: { text },
    schema: noteResponseSchema,
  });
  return note;
}

/** Só o autor edita. */
export async function updateNote(
  conversationId: string,
  noteId: string,
  text: string,
): Promise<Note> {
  const { note } = await request(`${base(conversationId)}/${encodeURIComponent(noteId)}`, {
    method: 'PATCH',
    body: { text },
    schema: noteResponseSchema,
  });
  return note;
}

/** O autor ou um administrador apaga (definitivo). */
export async function deleteNote(conversationId: string, noteId: string): Promise<void> {
  await request(`${base(conversationId)}/${encodeURIComponent(noteId)}`, { method: 'DELETE' });
}
